import React from 'react';
import { PropTypes } from 'prop-types';
import { Tab, Tabs } from '@material-ui/core';

import { getExplainerVideoTitle } from 'src/const';
import { TabScrollButton } from './TabScrollButton';
import { useStyles } from './useStyles';

export const MultipleVideoTabs = ({
  videoIds,
  currentVideo,
  onChangeVideo,
}) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Tabs
        className={styles.tabs}
        classes={{ indicator: styles.indicator }}
        value={currentVideo}
        onChange={onChangeVideo}
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        ScrollButtonComponent={TabScrollButton}
      >
        {videoIds.map((id) => (
          <Tab
            className={styles.tab}
            classes={{
              selected: styles.selected,
            }}
            key={id}
            label={getExplainerVideoTitle(id)}
            value={id}
          />
        ))}
      </Tabs>
    </div>
  );
};

MultipleVideoTabs.propTypes = {
  videoIds: PropTypes.arrayOf(PropTypes.string),
  currentVideo: PropTypes.string,
  onChangeVideo: PropTypes.func.isRequired,
};

MultipleVideoTabs.defaultProps = {
  videoIds: [],
  currentVideo: null,
};
